import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close as CloseIcon } from "@mui/icons-material";
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Box, Button, } from "@mui/material";
import { useScreenWidth } from "../hooks/useScreenWidth.js";
import { LoadingSpinner } from "../loading/LoadingSpinner.js";
import { useModalStack } from "./ModalStack.js";
export function Modal({ id, maxWidth, dialogProps, alwaysVisible = false, notInStack = false, fixedHeight = false, closeOnBackdropClick = false, title, icon, headerActions, headerButtons, titleProps, isLoading, contentContainerRef, contentProps, dialogActions, actionButtons, children, handleClose, }) {
    return (_jsxs(ModalDialog, { id: id, maxWidth: maxWidth, dialogProps: dialogProps, alwaysVisible: alwaysVisible, notInStack: notInStack, fixedHeight: fixedHeight, closeOnBackdropClick: closeOnBackdropClick, handleClose: handleClose, children: [_jsx(ModalTitle, { title: title, icon: icon, headerActions: headerActions, headerButtons: headerButtons, handleClose: handleClose, titleProps: titleProps }), _jsx(ModalContent, { isLoading: isLoading, contentContainerRef: contentContainerRef, contentProps: contentProps, children: children }), dialogActions ??
                (actionButtons && _jsx(ModalActions, { actionButtons: actionButtons }))] }));
}
export function ModalDialog({ id, maxWidth, dialogProps, alwaysVisible = false, notInStack = false, fixedHeight = false, fullHeight = false, closeOnBackdropClick = false, handleClose, children, }) {
    const { isTop } = useModalStack(notInStack);
    const { isMaxPhone } = useScreenWidth();
    const isFullScreen = isMaxPhone || dialogProps?.fullScreen;
    return (_jsx(Dialog, { id: id, open: true, onClose: (event, reason) => {
            if (reason === "backdropClick" && !closeOnBackdropClick)
                return;
            handleClose?.();
        }, onClick: e => e.stopPropagation(), fullScreen: isFullScreen, maxWidth: maxWidth, fullWidth: true, ...dialogProps, style: {
            display: isTop || alwaysVisible ? "block" : "none",
        }, PaperProps: {
            ...dialogProps?.PaperProps,
            ...(fixedHeight && !isFullScreen
                ? {
                    sx: {
                        height: "90%",
                        maxHeight: "1200px",
                        minHeight: "450px",
                        ...dialogProps?.PaperProps?.sx,
                    },
                }
                : undefined),
            ...(fullHeight && !isFullScreen
                ? {
                    sx: {
                        minHeight: 0,
                        height: "100%",
                        ...dialogProps?.PaperProps?.sx,
                    },
                }
                : undefined),
        }, children: children }));
}
export function ModalContent({ children, isLoading, contentContainerRef, contentProps, }) {
    return (_jsx(DialogContent, { ref: contentContainerRef, ...contentProps, children: isLoading ? _jsx(LoadingSpinner, {}) : children }));
}
export function ModalTitle({ title, icon, headerButtons, headerActions, handleClose, titleProps, }) {
    return (_jsxs(DialogTitle, { ...titleProps, sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            ...titleProps?.sx,
        }, children: [icon && (_jsx(Box, { mr: 1, display: "flex", flexGrow: 0, flexShrink: 0, children: icon })), _jsxs(Stack, { direction: "row", alignItems: "center", justifyContent: "flex-start", spacing: 1, flex: 1, minWidth: 0, children: [typeof title === "string" ? _jsx("span", { children: title }) : title, headerButtons] }), _jsxs(Stack, { direction: "row", alignItems: "center", justifyContent: "flex-end", spacing: 0.5, children: [headerActions, handleClose && (_jsx(IconButton, { style: { width: 40, height: 40, flexShrink: 0, flexGrow: 0 }, "aria-label": "Close", color: "default", onClick: handleClose, size: "large", children: _jsx(CloseIcon, {}) }))] })] }));
}
export function ModalActions({ actionButtons, }) {
    return (_jsx(DialogActions, { children: actionButtons.map(button => (_jsx(Button, { onClick: button.handleClick, variant: "contained", color: "primary", ...button.buttonProps, children: button.label }, button.label))) }));
}
//# sourceMappingURL=Modal.js.map